import { DateTime } from "luxon";
import { floor } from "lodash";
import dayjs from "dayjs";

export const humanFileSize = (bytes, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

export const formatDate = (epochMs) => {
  if (epochMs === undefined) return "";
  const dateFormat = DateTime.fromMillis(epochMs);
  return dateFormat.toLocaleString(DateTime.DATETIME_MED);
};

export const formatSeconds = (seconds) => {
  let value = seconds;
  const hours = floor(value / 3600.0);
  value -= hours * 3600;
  const minutes = floor(value / 60.0);
  value -= minutes * 60;

  let s = "";
  if (hours < 10) s += "0";
  s += hours + ":";
  if (minutes < 10) s += "0";
  s += minutes + ":";
  if (value < 10) s += "0";
  s += value.toFixed(3);
  return s;
};

export const dump = (v) => {
  console.log("lllllllllll", v);
  return "dump";
};

export const formatStatus = (value) => {
  switch (value) {
    case "WAITING_FOR_FILES":
      return "WAITING FOR FILES";
    case "POST_PROCESSING":
      return "POST PROCESSING";
    case "GLIMPSE_ERROR":
      return "GLIMPSE ERROR";
    case "GLIMPSE_COMPLETE":
      return "GLIMPSE COMPLETE";
    case "NOISE_FILTERING":
      return "NOISE FILTERING";
    default:
      return value;
  }
};

export const formatCommitType = (value) => {
  switch (value) {
    case "NORMALIZATION_COMPLETE":
    case "NORMALIZATION_FILTER_COMPLETE":
      return "NORMALIZATION";
    case "FILTER_MERGE":
      return "AUDIO MERGE";
    case "FILTER_CUT":
      return "AUDIO CUT";
    default:
      return value;
  }
};

export const formatLastModifiedDate = (d) => {
  const date = new Date(parseInt(d));
  return dayjs(date).format("MM/DD/YYYY HH:mm A");
};
